// Photo viewer on the native <dialog> (focus trap, Esc and the backdrop come
// free). Photos opt in as `<a href="large.jpg" data-lightbox="group">`; the
// arrows move within the clicked photo's group only, skipping photos hidden
// by a filter. Optional `data-lightbox-label`, `-title` and `-caption` on the
// link fill a caption under the photo. A repeat of a photo (a looping row's
// copy) links `data-lightbox-original="{id of the original link}"` instead.
export function initLightbox() {
  const dialog = document.getElementById("cms-lightbox");
  if (!dialog) return;
  const image = dialog.querySelector(".cms-lightbox__image");
  const counter = dialog.querySelector(".cms-lightbox__counter");
  const caption = dialog.querySelector(".cms-lightbox__caption");
  const meta = dialog.querySelector(".cms-lightbox__meta");
  const title = dialog.querySelector(".cms-lightbox__title");
  const text = dialog.querySelector(".cms-lightbox__text");
  let links = [];
  let index = 0;

  function show(i) {
    index = (i + links.length) % links.length;
    const link = links[index];
    image.src = link.href;
    image.alt = link.querySelector("img")?.alt || "";
    const position = links.length > 1 ? `${index + 1} / ${links.length}` : "";
    const { lightboxLabel = "", lightboxTitle = "", lightboxCaption = "" } = link.dataset;
    const hasCaption = Boolean(lightboxLabel || lightboxTitle || lightboxCaption);
    // With a caption the position goes into it ("Imprezy · 3 / 20"), as in the
    // gallery design; without one it stays in the corner counter.
    caption.hidden = !hasCaption;
    meta.textContent = [lightboxLabel, position].filter(Boolean).join(" · ");
    title.textContent = lightboxTitle;
    text.textContent = lightboxCaption;
    counter.textContent = hasCaption ? "" : position;
    dialog.classList.toggle("is-single", links.length < 2);
  }

  document.addEventListener("click", (event) => {
    // A repeat of a photo (a looping row's copy) stands in for its original.
    const copy = event.target.closest("a[data-lightbox-original]");
    const link = copy
      ? document.getElementById(copy.dataset.lightboxOriginal)
      : event.target.closest("a[data-lightbox]");
    if (!link) return;
    event.preventDefault();
    // Only photos that are on screen: a gallery tab may be hiding the rest.
    links = [...document.querySelectorAll(`a[data-lightbox="${link.dataset.lightbox}"]`)]
      .filter((a) => a === link || a.offsetParent !== null);
    show(links.indexOf(link));
    dialog.showModal();
  });

  dialog.addEventListener("click", (event) => {
    const step = event.target.closest("[data-lightbox-step]");
    if (step) return show(index + Number(step.dataset.lightboxStep));
    // A click on the dimmed area lands on the dialog itself, not its contents.
    if (event.target === dialog || event.target.closest("[data-lightbox-close]")) dialog.close();
  });

  dialog.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft") show(index - 1);
    if (event.key === "ArrowRight") show(index + 1);
  });

  let touchX = null;
  dialog.addEventListener("touchstart", (event) => { touchX = event.touches[0].clientX; }, { passive: true });
  dialog.addEventListener("touchend", (event) => {
    if (touchX === null) return;
    const dx = event.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
  });

  // Drop the photo on close so the next open never flashes the previous one.
  dialog.addEventListener("close", () => image.removeAttribute("src"));
}
